import { render, staticRenderFns } from "./P2PLayout.vue?vue&type=template&id=405bd8e2&"
import script from "./P2PLayout.vue?vue&type=script&lang=ts&"
export * from "./P2PLayout.vue?vue&type=script&lang=ts&"
import style0 from "./P2PLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports